import studiesActions from './actionTypes.js'
import studiesMutations from './mutationTypes.js'
import Vue from 'vue'
import apiFunctions from '../../../helpers/apiFunctions.js'
import generalActions from '../general/actionTypes.js'

const actions = {
  [studiesActions.FETCH_STUDIES]: async ({ dispatch }, { sq, fullSq }) => {
    const response = await Vue.axios.post('/smartsearch/', { query: sq, full_query: fullSq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FIELDS]: async ({ dispatch, commit }) => {
    const response = await Vue.axios.post('/smartsearch/dropdown_options', { query: [], full_query: [] })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_SEARCH_FIELDS, response.data.fields)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDY_SUMMARIES]: async ({ dispatch, commit }, sq) => {
    const response = await Vue.axios.post('/smartsearch/study_summarises', { query: sq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCES]: async ({ dispatch, commit }, sq) => {
    const response = await Vue.axios.post('/smartsearch/fragrances', { query: sq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_FRAGRANCES, response.data)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CONCEPTS]: async ({ dispatch, commit }, sq) => {
    const response = await Vue.axios.post('/smartsearch/concepts', { query: sq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_CONCEPTS, response.data)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.SET_FRAGRANCES]: async ({ commit }, data) => {
    commit(studiesMutations.SET_FRAGRANCES_DETAILS, data)
  },
  [studiesActions.SET_CONCEPTS]: async ({ commit }, data) => {
    commit(studiesMutations.SET_CONCEPTS_DETAILS, data)
  },
  [studiesActions.FETCH_FILES]: async ({ dispatch, commit }, { sq, fullSq, fileType }) => {
    const response = await Vue.axios.post(`/smartsearch/files/${fileType}`, { query: sq, full_query: fullSq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_FILES, { fileType, data: response.data })
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_METRIC_SEARCH]: async ({ dispatch, commit }, { q, data, noCache }) => {
    const response = await Vue.axios.post(
      `/analytics/fragrances`,
      data ? { ...q, fragrances: data } : q,
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data.results)
      commit(studiesMutations.SET_JOB_ID, { job: 'metrics', id: response.data.jobid })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_METRIC_SEARCH_AND_GET_JOB_ID]: async ({ dispatch, commit }, { q, data, noCache }) => {
    const response = await Vue.axios.post(
      `/analytics/fragrances`,
      data ? { ...q, fragrances: data } : q,
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data.results)
      return response.data.jobid
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_PERFORMANCE_SEARCH]: async ({ dispatch, commit }, { q, data, frags, noCache }) => {
    const response = await Vue.axios.post(
      `/analytics/fragrances`,
      { ...q, grouping: [data], fragrances: frags },
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data.results)
      commit(studiesMutations.SET_JOB_ID, { job: 'performance', id: response.data.jobid })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_ATTRIBUTES_SEARCH]: async ({ dispatch, commit }, { q, data, frags, noCache }) => {
    const query = {
      query: q.query,
      demographics: q.demographics,
      responses: q.responses,
      metrics: q.metrics,
      ...data,
      frags
    }
    const response = await Vue.axios.post(
      `/analytics/top-attributes`,
      query,
      { params: { no_cache: true } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_JOB_ID, { job: 'attributes', id: response.data.jobid })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_TENDENCIES]: async ({ dispatch, commit }, { q, data, frags, noCache }) => {
    const query = {
      query: q.query,
      metrics: q.metrics,
      ...data,
      frags
    }
    const response = await Vue.axios.post(
      `/analytics/tendencies`,
      query,
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'tendencies', data: response.data })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_METRIC_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await Vue.axios.get(`/analytics/fragrances/${jobId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.data.status === 'SUCCESS') {
        const results = (
          response &&
          response.data &&
          response.data.result &&
          response.data.result.json
        ) ? response.data.result.json : {}
        commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'metrics', data: results })
        return true
      }
      return ['FAILURE', 'REVOKED'].includes(response.data.status)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_STUDY_FILE_UPLOAD_STATUS]: async ({ dispatch, commit }, { jobId, studyId }) => {
    try {
      const response = await Vue.axios.get(`/study/${studyId}/upload/${jobId}`)
      return response.data
    } catch (err) {
      if (err.response.data && err.response.data.message) {
        return err.response.data.message
      }
      return { 'status': 'failed' }
    }
  },
  [studiesActions.CHECK_METRIC_JOB_STATUS_AND_GET_DATA]: async ({ dispatch, commit }, jobId) => {
    const response = await Vue.axios.get(`/analytics/fragrances/${jobId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.data.status === 'SUCCESS') {
        return response.data
      }
      return ['FAILURE', 'REVOKED'].includes(response.data.status)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_PERFORMANCE_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await Vue.axios.get(`/analytics/fragrances/${jobId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.data.status === 'SUCCESS') {
        commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'performance', data: response.data.result.json.results })
        return true
      }
      return ['FAILURE', 'REVOKED'].includes(response.data.status)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_ATTRIBUTES_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await Vue.axios.get(`/analytics/top-attributes/${jobId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.data.status === 'SUCCESS') {
        commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'attributes', data: response.data.result.json })
        return true
      }
      return ['FAILURE', 'REVOKED'].includes(response.data.status)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_METRIC_XLSX_JOB_STATUS]: async ({ dispatch, commit }, { jobId, filters }) => {
    const response = await Vue.axios({
      url: `/analytics/fragrances/xlsx/${jobId}`,
      method: 'GET',
      params: { filters: filters },
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_PERFORMANCE_XLSX_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await Vue.axios({
      url: `/analytics/fragrances/xlsx/${jobId}`,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_ATTRIBUTES_XLSX_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await Vue.axios({
      url: `/analytics/top-attributes/xlsx/${jobId}`,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_SUMMARIES_XLSX]: async ({ dispatch, commit }, { q }) => {
    const response = await Vue.axios({
      url: `/smartsearch/download_study_summarises`,
      method: 'POST',
      data: q,
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (!response.data.status) {
        return response.data
      }
      return false
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCE_XLSX]: async ({ dispatch, commit }, { q }) => {
    const response = await Vue.axios({
      url: `/smartsearch/download_fragrances`,
      method: 'POST',
      data: q,
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (!response.data.status) {
        return response.data
      }
      return false
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCE_XLSX_FILTERS]: async ({ dispatch }) => {
    const response = await Vue.axios.get(`/analytics/fragrances/xlsxfilters`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CICS_QUESTIONS]: async ({ dispatch, commit }, q) => {
    const response = await Vue.axios.post(`/cics/search_bar/`, q)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_CICS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CICS_QUESTION_DATA]: async ({ dispatch, commit }, { q, id }) => {
    const response = await Vue.axios.post(`/cics/inspect_question/${id}/`, q)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_ANALYTICS_FIELDS]: async ({ dispatch }) => {
    const response = await Vue.axios.get(`/analytics/options`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CICS_FIELDS]: async ({ dispatch }) => {
    const response = await Vue.axios.get(`/cics/options`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_QUESTIONS]: async ({ dispatch, commit }, id) => {
    const response = await Vue.axios.get('/study/' + id + '/questions/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_QUESTIONS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CLEAR_QUESTIONS]: async ({ dispatch, commit }) => {
    commit(studiesMutations.SET_QUESTIONS, [])
  },
  [studiesActions.FETCH_METRICS]: async ({ dispatch }) => {
    const response = await Vue.axios.get('/study/metrics/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCE_PROFILE]: async ({ dispatch }, { id, code, data }) => {
    let response = null
    try {
      response = await Vue.axios.post(`/study/${id}/fragrance/${code}`, data)
    } catch (e) {
      response = e
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.status === 400 ? null : response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CONCEPT_PROFILE]: async ({ dispatch }, { id, code, data }) => {
    let response = null
    try {
      response = await Vue.axios.post(`/study/${id}/concept/${code}`, data)
    } catch (e) {
      response = e
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.status === 400 ? null : response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.SET_OR_CLEAR_SEARCH_FILTERS]: async ({ dispatch, commit }, { clearFilters, filters }) => {
    if (clearFilters) {
      commit(studiesMutations.RESET_SEARCH_FILTERS)
    } else {
      commit(studiesMutations.SET_SEARCH_FILTERS, filters)
    }
  },
  [studiesActions.RESET_SEARCH_FILTERS]: async ({ commit }) => {
    commit(studiesMutations.RESET_SEARCH_FILTERS)
  },
  [studiesActions.APPLY_SEARCH_FILTERS]: async ({ commit }, filters) => {
    commit(studiesMutations.APPLY_SEARCH_FILTERS, filters)
  },
  [studiesActions.UPDATE_CICS_FILTERS]: async ({ commit }, filters) => {
    commit(studiesMutations.SET_CICS_FILTERS, filters)
  },
  [studiesActions.RESET_CICS_FILTERS]: async ({ commit }) => {
    commit(studiesMutations.RESET_CICS_FILTERS)
  },
  [studiesActions.APPLY_CICS_FILTERS]: async ({ commit }, filters) => {
    commit(studiesMutations.APPLY_CICS_FILTERS, filters)
  },
  [studiesActions.CLEAR_STUDY_SUMMARIES]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_STUDY_SUMMARIES)
  },
  [studiesActions.CLEAR_FRAGRANCES]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_FRAGRANCES)
  },
  [studiesActions.CLEAR_CONCEPTS]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_CONCEPTS)
  },
  [studiesActions.CLEAR_FILES]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_FILES)
  },
  [studiesActions.CLEAR_ANALYTICS]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_ANALYTICS)
  },
  [studiesActions.FETCH_STUDY_FILES]: async ({ dispatch }, id) => {
    const response = await Vue.axios.get('/study/' + id + '/study-files/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_RELATED_STUDY_FILES]: async ({ dispatch }, id) => {
    const response = await Vue.axios.get('/study/' + id + '/related-study-files/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDY_TAGS]: async ({ dispatch, commit }) => {
    const response = await Vue.axios.get('/study/options')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_TAGS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDY_DETAILS]: async ({ dispatch, commit }, id) => {
    const response = await Vue.axios.get('/study/' + id)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_DETAILS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPDATE_STUDY_DETAILS]: async ({ dispatch }, { id, data }) => {
    const response = await Vue.axios.put('/study/' + id, data)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPDATE_STUDY_MAPPING]: async ({ dispatch }, { id, query }) => {
    const response = Vue.axios.put('/study/' + id + '/question/', { q_upd: query })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPDATE_DROPDOWN_OPTIONS]: async ({ dispatch }, { query }) => {
    const response = Vue.axios.post('/smartsearch/dropdown_options', { query })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS]: async ({ dispatch }, { query, queryMetrics, rdfType, irtImplict }) => {
    const response = Vue.axios.post('/smartsearch/dropdown_options_analytics', { query: query, query_metrics: queryMetrics, rdf_type: rdfType, irt_implict: irtImplict })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_SAVED_SEARCHES]: async ({ dispatch, commit }, { userId, type }) => {
    const response = await Vue.axios.get(`/users/${userId}/searches/`, { params: { search_type: type } })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_SAVED_SEARCHES, response)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDIES_COUNT]: async ({ dispatch, commit }) => {
    const response = await Vue.axios.get(`/smartsearch/count`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDIES_COUNT, response)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.POST_SAVED_SEARCH]: async ({ dispatch }, { userId, data, type }) => {
    const response = await Vue.axios.post(`/users/${userId}/searches/`, { ...data, search_type: type })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.status === 200) {
        dispatch(studiesActions.FETCH_SAVED_SEARCHES, { userId, type })
      }
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.POST_TAG_EDIT]: async ({ dispatch, commit }, { studyId, data, tagKey }) => {
    let response
    try {
      response = await Vue.axios.put(`/study/${studyId}`, data)
    } catch (e) {
      let errorMessage
      if (e.response) {
        errorMessage = e.response.status === 400 ? e.response.data : 'Something went wrong, please try again later.'
      } else {
        errorMessage = 'Something went wrong, please try again later.'
      }
      commit(studiesMutations.SET_STUDY_ERROR, { message: errorMessage, key: tagKey || 'main' })
      return e.response
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.status === 200) {
        commit(studiesMutations.UPDATE_STUDY_DETAILS, data)
      }
      commit(studiesMutations.SET_STUDY_ERROR, null)
      return true
    } else {
      dispatch(generalActions.SET_ERROR)
      return responseObject.data
    }
  },
  [studiesActions.DELETE_SAVED_SEARCH]: async ({ dispatch }, { userId, data, type }) => {
    const response = await Vue.axios.delete(`/users/${userId}/searches/`, { data })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.status === 200) {
        dispatch(studiesActions.FETCH_SAVED_SEARCHES, { userId, type })
      }
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FILE]: async ({ dispatch }, { studyId, fileId }) => {
    const response = await Vue.axios({
      url: '/study/' + studyId + '/study-files/' + fileId,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.EDIT_STUDIES]: async ({ dispatch }, data) => {
    const response = await Vue.axios.put('/smartsearch/update', data)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_TENDENCIES_XLSX]: async ({ dispatch }, { q, data, frags }) => {
    const query = {
      query: q.query,
      metrics: q.metrics,
      ...data,
      frags
    }
    const response = await Vue.axios({
      url: '/analytics/tendencies/xlsx',
      method: 'POST',
      responseType: 'blob',
      data: query
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.GET_FRAGRANCE_PROFILE_XLSX]: async ({ dispatch }, { id, code, q }) => {
    const response = await Vue.axios({
      url: `/study/${id}/fragrance/${code}/xlsx`,
      method: 'POST',
      responseType: 'blob',
      data: q
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_SIGNIFICANCE_CALCULATION]: async ({ dispatch, commit }, { q, data }) => {
    const query = {
      data: data,
      calculation: q.calculation,
      metrics: q.metrics
    }
    console.log('signif query', query)
    const response = await Vue.axios.post('/analytics/significance', query)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_JOB_ID, { job: 'significance', id: response.data.job_id })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_SIGNIFICANCE_JOB_STATUS]: async ({ dispatch, commit }, { jobId }) => {
    const response = await Vue.axios.get(`/analytics/significance/${jobId}`)
    console.log('signif response', response)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.data.status === 'SUCCESS') {
        commit(studiesMutations.SET_SIGNIFICANCE_RESULTS, response.data.result.results)
        return true
      }
      return response.data.status === 'failed' || response.data.status === 'FAILURE'
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPLOAD_STUDIES]: async ({ dispatch }, { file, form, onProgress }) => {
    const formData = new FormData()
    formData.append('file', file)
    for (const key in form) {
      formData.append(key, form[key])
    }
    const response = await Vue.axios.post('/fileprocess/studies_upload', formData, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        if (onProgress) onProgress(percentCompleted)
      }
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_PROCESS_FILE_DETAILS]: async ({ dispatch, commit }, { fileProcessId }) => {
    const response = await Vue.axios.get(`/fileprocess/file-process/${fileProcessId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPDATE_FILE_PROCESS]: async ({ dispatch, commit }, { fileProcessId, filePath, file, onProgress }) => {
    const formData = new FormData()
    formData.append('filepath', filePath)
    formData.append('file', file)
    const response = await Vue.axios.put(`/fileprocess/fileprocess/${fileProcessId}/replace_file`, formData, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        if (onProgress) onProgress(percentCompleted)
      }
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.PROCESS_STUDIES]: async ({ dispatch, commit }, { fileProcessId, onProgress }) => {
    const response = await Vue.axios.post(`/fileprocess/fileprocess/${fileProcessId}/process_studies`, {}, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        if (onProgress) onProgress(percentCompleted)
      }
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.DOWNLOAD_FILE_FROM_FILE_PROCESS]: async ({ dispatch, commit }, { processId, filePath }) => {
    const filepath = btoa(filePath)
    const response = await Vue.axios({
      url: `/fileprocess/${processId}/${filepath}/download`,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.SEND_RDF_DATA]: async ({ dispatch, commit }, { dataForm, studyId = '' }) => {
    const formData = new FormData()

    Object.keys(dataForm).forEach(key => formData.append(key, dataForm[key]))
    if (studyId) formData.append('study_id', studyId)

    const response = await Vue.axios.post('/rdf/rdf_upload', formData)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.FETCH_FILE_PROCESS]: async ({ dispatch }) => {
    const response = await Vue.axios({
      url: '/fileprocess/file-processes',
      method: 'GET'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.GET_STUDY_METRICS]: async ({ dispatch }, { studyId }) => {
    const response = await Vue.axios({
      url: `/study/metrics/${studyId}`,
      method: 'GET'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.FETCH_STUDY_EDIT_HISTORY]: async ({ dispatch, commit }, id) => {
    const response = await Vue.axios({
      url: `/study/study_edit_history/${id}`,
      method: 'GET'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.UPLOAD_RDF_DATA]: async ({ dispatch }, { formData, method }) => {
    let response
    if (method.toLowerCase() === 'post') {
      response = await Vue.axios.post('/rdf/rdf_file_metrics', formData)
    } else if (method.toLowerCase() === 'put') {
      response = await Vue.axios.put('/rdf/rdf_file_metrics', formData)
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.CHECK_ALL_CLOSE_ENDED_QUESTIONS]: async ({ dispatch }, { formData }) => {
    const response = await Vue.axios.post('/rdf/check_all_close_ended_questions', formData)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  }
}

export default {
  ...actions
}
